/* ==========================================================================
   LSC - Collage Collection: floating bar (created 16 Oct 2026, v7;
   v8 16 Oct 2026: always on screen)
   assets/lsc-collage-collection-floating.js

   Keeps the floating "Show filters" + Collage / List bar
   (snippets/lsc-collage-collection-floating-bar.liquid) clear of the
   theme's phone dock. Loaded by sections/lsc-collage-collection.liquid
   when filtering or the view toggle is on. The buttons themselves need
   nothing from this file: the filter buttons open the theme's drawers
   through aria-controls, and the toggle buttons are handled by
   assets/lsc-collage-collection-view.js.

   v8: the bar shows ALL the time, at every screen size, from the first
   paint (plain CSS; this script plays no part in that). v7's show / hide
   rules (products on screen, toolbar scrolled away, sticky-header check)
   were removed along with the toolbar row above the products.

   PHONE DOCK
   The theme's .mobile-dock bar sits at the bottom of phone screens when it
   is showing. The bar is lifted by the dock's visible height
   (--lsc-cc-fab-lift), measured on load and re-measured on scroll and
   resize (one getBoundingClientRect per frame at most). Without this
   script the bar sits at its normal 20px from the bottom, which on phones
   can overlap the dock.

   THE EDITOR
   shopify:section:load re-scans (each root is set up once). The scroll and
   resize listeners are shared by all bars on the page.

   LSC - v13 (18 Oct 2026): BOTTOM-GAP FIX. On iPhones a Safari viewport bug
   can leave fixed bottom bars floating above the bottom of the screen.
   snippets/lsc-fixed-bottom-fix.liquid (rendered from layout/theme.liquid)
   measures that gap and moves this bar AND the phone dock down by it
   (CSS translate). Because the dock is moved too, its measured top is
   lower by the same amount, which would make the lift too small and the
   bar overlap the dock; dockHeight() adds the gap back
   (window.LscFixedBottom.gap(), 0 when the fix is not loaded or no gap).
   The bar also re-lifts on the fix's 'lsc:vv-gap' event.
   ========================================================================== */
(function () {
  if (window.LscCcFloating) {
    window.LscCcFloating.scan();
    return;
  }

  var bars = []; // every floating bar set up so far
  var queued = false;

  /** Height of the theme's phone dock that is on screen, in px (0 if none). */
  function dockHeight() {
    var dock = document.querySelector('.mobile-dock');
    if (!dock) return 0;
    var rect = dock.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    // LSC - v13: the gap fix moves the dock down by `gap` px, so its
    // bottom edge is at viewport + gap, not viewport (see the header).
    var gap = window.LscFixedBottom ? window.LscFixedBottom.gap() : 0;
    var bottom = viewport + gap;
    if (!rect.height || rect.top >= bottom || getComputedStyle(dock).visibility === 'hidden') return 0;
    return Math.max(0, Math.round(bottom - rect.top));
  }

  /** Lift every bar above the dock (or back down when it has gone). */
  function lift() {
    var amount = dockHeight() + 'px';
    bars.forEach(function (bar) {
      if (!bar.isConnected) return; // removed in the editor
      if (bar.style.getPropertyValue('--lsc-cc-fab-lift') !== amount) {
        bar.style.setProperty('--lsc-cc-fab-lift', amount);
      }
    });
  }

  /** At most one measurement per frame while scrolling or resizing. */
  function queueLift() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      lift();
    });
  }

  function scan() {
    document.querySelectorAll('[data-lsc-cc] [data-lsc-cc-fab]').forEach(function (bar) {
      if (bars.indexOf(bar) === -1) bars.push(bar);
    });
    lift();
  }

  window.addEventListener('scroll', queueLift, { passive: true });
  window.addEventListener('resize', queueLift);
  document.addEventListener('lsc:vv-gap', queueLift); // LSC - v13: gap fix changed the gap
  document.addEventListener('shopify:section:load', scan);

  window.LscCcFloating = { scan: scan, lift: lift };
  scan();
})();
